import { createUseStyles } from 'react-jss';
export var useStyles = createUseStyles(function (theme) {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '1rem',
      width: 'auto',
      height: 'auto'
    },
    content: {
      display: 'flex',
      height: '100%',
      width: '100%',
      position: 'relative'
    },
    input: {
      border: "1px solid ".concat(theme.palette.grey[8]),
      borderRadius: '0.5rem',
      color: theme.palette.text,
      fontFamily: 'Ubuntu',
      fontSize: 15,
      height: 48,
      padding: '0 15px',
      width: '100%',
      '&::placeholder': {
        color: theme.palette.grey[11]
      },
      '&:disabled': {
        background: theme.palette.grey[1],
        color: theme.palette.grey[8]
      },
      '&:focus': {
        borderColor: theme.palette.primary.regular,
        color: theme.palette.text,
        opacity: 1,
        outline: 'none'
      },
      '&[name=password]': {
        padding: '1.8rem 5rem 1.8rem 1.8rem'
      }
    },
    inputError: {
      borderColor: theme.palette.red.light,
      opacity: 1,
      outline: 'none',
      '&:focus': {
        borderColor: theme.palette.red.regular,
        opacity: 1,
        outline: 'none'
      }
    },
    inputPassword: {
      fontSize: 22
    },
    inputIcon: {
      paddingRight: 48
    },
    iconButton: {
      position: 'absolute',
      right: 0,
      top: 0,
      zIndex: 999,
      padding: 13
    },
    bottomError: {
      marginTop: 3
    },
    topError: {
      top: 0,
      position: 'absolute'
    }
  };
});